export default __webpack_public_path__ + "static/media/instagram.1ef8427f.svg";